import { FileUrl } from '~/modules/TrophyMemories/Domain/FileUrl'

const audioThumbnailFileUrl = '/img/defaults/audio-thumbnail.svg'
const audioThumbnailFileUrlFilename = 'audio-thumbnail.svg'
const audioThumbnailFileUrlExtension = 'svg'

export class AudioThumbnailSvgFileUrl extends FileUrl {
  public static canParse (url: string): boolean {
    return url === audioThumbnailFileUrl
  }

  public toString (): string {
    return audioThumbnailFileUrl
  }

  getExtension (): string {
    return audioThumbnailFileUrlExtension
  }

  getFilename (): string {
    return audioThumbnailFileUrlFilename
  }
}
